import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRestaurant } from '../context/RestaurantContext';
import './RestaurantSelectorPage.css';

const RestaurantSelectorPage = ({ user }) => {
  const navigate = useNavigate();
  const { setSelectedRestaurant } = useRestaurant();

  const handleSelectRestaurant = (restaurantId) => {
    setSelectedRestaurant(restaurantId);
    navigate('/'); // Redirige al dashboard principal
  };

  return (
    <div className="selector-container">
      <div className="selector-box">
        <h2>Selecciona un Restaurante</h2>
        <p>Elige el dashboard al que quieres acceder.</p>
        <div className="restaurant-list">
          {/* Ahora mapea sobre la lista de objetos 'restaurants' del usuario */}
          {user?.restaurants?.map(restaurant => (
            <button 
              key={restaurant.id} 
              className="restaurant-button"
              onClick={() => handleSelectRestaurant(restaurant.id)}
            >
              {restaurant.name} {/* Muestra el nombre completo */}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RestaurantSelectorPage;